import { isParagraph } from 'datocms-structured-text-utils'
import { renderMarkRule, renderNodeRule, StructuredText } from 'react-datocms/structured-text'

import type { TextWithHighlightFragment } from '@/lib/types/datocms/graphql/generated'

type Props = {
	text: TextWithHighlightFragment
	theme?: string
}

export function TextWithHighlight({ text }: Props) {
	if (!text) return null

	return (
		<StructuredText
			data={text.text}
			customMarkRules={[
				renderMarkRule('strong', ({ children, key }) => {
					return <strong key={key}>{children}</strong>
				}),
			]}
			customNodeRules={[
				renderNodeRule(isParagraph, ({ children, key }) => {
					return <span key={key}>{children}</span>
				}),
			]}
		/>
	)
}
